import React, { useState } from 'react';
import { testAuth, setToken } from '../api/scout';
import { ACCENT } from '../contexts/ThemeContext';

function CorosHex({ size = 32 }) {
  return (
    <svg viewBox="0 0 80 90" fill="currentColor" style={{ width: size, height: size * 1.125, color: ACCENT }}>
      <path d="M8.51 57.53L35.78 73.23L63.41 61.51V67.12L32.34 85L0 66.39V30.62L5.05 27.5L8.5 57.52ZM47.9 11.8L20.67 27.56L17 57.36L12.14 54.55L12.19 18.7L44.48 0L75.44 17.88L75.62 23.82L47.89 11.8ZM67.8 69.11L67.76 37.65L43.79 19.58L48.65 16.77L79.67 34.74L79.72 72.05L48.75 89.93L43.52 87.11L67.8 69.11Z" />
    </svg>
  );
}

export default function Login({ onLogin }) {
  const [token, setTokenValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!token.trim()) return;
    setLoading(true);
    setError('');
    try {
      const ok = await testAuth(token.trim());
      if (ok) {
        setToken(token.trim());
        onLogin();
      } else {
        setError('Invalid access token');
      }
    } catch {
      setError('Connection failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
      background: '#0D0F16',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Atmosphere */}
      <div className="atmosphere">
        <div className="atmo-grid" />
        <div className="atmo-blob b1" />
        <div className="atmo-blob b2" />
        <div className="atmo-blob b3" />
        <div className="atmo-radar" />
        <div className="atmo-mountains" />
      </div>

      <div style={{ width: '100%', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
        {/* Brand */}
        <div style={{
          textAlign: 'center', marginBottom: '48px',
          animation: 'fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards',
        }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <CorosHex size={36} />
          </div>
          <h1 style={{
            fontSize: '28px', fontWeight: 800, letterSpacing: '-0.02em',
            color: '#F0F0F4', lineHeight: 1.15,
          }}>
            SCOUT
          </h1>
          <p style={{
            fontSize: '13px', color: '#454966', fontWeight: 500,
            marginTop: '8px',
          }}>
            COROS Ticket Intelligence
          </p>
        </div>

        {/* Login form */}
        <form onSubmit={handleSubmit} style={{
          padding: '32px',
          borderRadius: '16px',
          background: 'rgba(27, 30, 43, 0.65)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.06)',
          boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
          animation: 'fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.12s forwards',
          opacity: 0,
        }}>
          {/* Orange arc accent */}
          <div style={{
            position: 'absolute', top: '-1px', left: '24px',
            width: '100px', height: '3px', borderRadius: '0 0 4px 4px',
            background: 'linear-gradient(90deg, #E52E3A, #FF4551, transparent)',
            animation: 'arcGrow 1s cubic-bezier(0.16, 1, 0.3, 1) 0.5s both',
          }} />

          <label style={{
            display: 'block', fontSize: '11px', fontWeight: 600,
            color: '#6B6F84', marginBottom: '8px',
            letterSpacing: '0.04em', textTransform: 'uppercase',
          }}>
            Access Token
          </label>
          <input
            type="password"
            value={token}
            onChange={e => setTokenValue(e.target.value)}
            placeholder="Enter your access token"
            className="input"
            style={{
              width: '100%', marginBottom: '20px',
              background: '#232636', border: '1px solid rgba(255,255,255,0.08)',
              color: '#F0F0F4',
            }}
            autoFocus
          />

          {error && (
            <p style={{
              fontSize: '12px', color: '#F87171', marginBottom: '16px',
              padding: '10px 14px', borderRadius: '10px',
              background: 'rgba(239, 68, 68, 0.06)',
              border: '1px solid rgba(239, 68, 68, 0.12)',
              fontWeight: 500,
            }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={!token.trim() || loading}
            className="btn-primary"
            style={{ width: '100%' }}
          >
            {loading ? 'Verifying...' : 'Sign In →'}
          </button>
        </form>

        <p style={{
          textAlign: 'center', fontSize: '12px', color: '#454966',
          marginTop: '24px', fontWeight: 500,
          animation: 'fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.24s forwards',
          opacity: 0,
        }}>
          Contact Mike for access
        </p>
      </div>
    </div>
  );
}
